import React, { CSSProperties } from 'react';
import { get } from 'lodash';
import classNames from 'classnames';
import { ITableColumn } from 'src/components/Table/types';
import './TableRow.scss';

interface TableRowProps {
  data: any;
  columns: ITableColumn[];
  index: number | string;
  style?: CSSProperties;
  emphasis?: boolean;
}

const TableRow = ({
  data,
  columns,
  index,
  style,
  emphasis = false,
}: TableRowProps) => {
  return (
    <div
      role="row"
      key={`table-row-container${index}`}
      className="juniper-datatable-row"
      style={style}
    >
      {columns.map((c: ITableColumn, x: number) => (
        <div
          role="cell"
          key={`table-td=${x}-${data.id}-${index}`}
          className={classNames('juniper-datatable-cell', {
            'juniper-datatable-center': c.center,
            'juniper-datatable-wrap': c.textOverflow,
            'juniper-datatable-sticky-col': c.sticky,
            'juniper-datatable-emphasis': emphasis,
          })}
        >
          {c.cell ? c.cell(data) : get(data, c.accessor)}
        </div>
      ))}
    </div>
  );
};

export default TableRow;
